"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _header = _interopRequireDefault(require("../header"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _tabs = _interopRequireDefault(require("../tabs"));

var _message = _interopRequireDefault(require("../../preact-components/design-system-components/message"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _inactivityBanner = _interopRequireDefault(require("@insided/control/modules/Core/inactivity-banner"));

var DataProgressBanner = function DataProgressBanner() {
  return (0, _preact.h)("div", {
    className: "data-progress-banner"
  }, (0, _preact.h)(_assets.default, {
    icon: "info",
    width: 20,
    height: 20,
    color: "#9599A2"
  }), (0, _preact.h)("span", null, (0, _preact.h)("span", {
    className: "data-progress-banner__bold-text"
  }, "Data Processing in Progress: "), (0, _preact.h)("span", {
    className: "data-progress-banner__normal-text"
  }, "You can access the data, but full availability may take up to 48 hours.")));
};

var IntegrationSetup = function IntegrationSetup(_ref) {
  var headerTitle = _ref.headerTitle,
      appLogoName = _ref.appLogoName,
      appContainerBackgroundColor = _ref.appContainerBackgroundColor,
      installButton = _ref.installButton,
      description = _ref.description,
      tabTitles = _ref.tabTitles,
      tabContents = _ref.tabContents,
      messageType = _ref.messageType,
      message = _ref.message,
      displayShowMoreLink = _ref.displayShowMoreLink,
      onClickTab = _ref.onClickTab,
      dismissMessage = _ref.dismissMessage,
      activeTab = _ref.activeTab,
      uninstallModal = _ref.uninstallModal,
      installedOn = _ref.installedOn,
      activityStatus = _ref.activityStatus;
  var isVisibleFor = 5000;
  var showDataProcessingDelayBanner = installedOn && headerTitle !== 'S3 Connector' ? new Date().getTime() - new Date(installedOn).getTime() <= 48 * 60 * 60 * 1000 : false;
  var shouldShowBanner = showDataProcessingDelayBanner && tabTitles[activeTab] === 'Installation';
  var shouldShowInactivityBanner = installedOn && activityStatus === 'deactivated' ? 'installed' : activityStatus;
  return (0, _preact.h)("div", {
    className: "installation__page"
  }, (0, _preact.h)(_header.default, {
    title: headerTitle,
    disableCancelButton: true,
    disableSaveButton: true,
    hasBreadcrumb: true,
    breadcrumbText: "Back to apps",
    breadcrumbLink: "/settings/integrations",
    statusLabelSuccess: true
  }), messageType && (0, _preact.h)(_message.default, {
    isControl: true,
    variant: messageType,
    onDismiss: dismissMessage,
    timer: isVisibleFor
  }, message), (0, _preact.h)("div", {
    className: "installation__sections"
  }, (0, _preact.h)("section", {
    className: "installation__left_section"
  }, (0, _preact.h)("div", {
    className: "installation__logo",
    style: {
      backgroundColor: appContainerBackgroundColor
    }
  }, (0, _preact.h)("div", {
    className: "installation__logo_wrapper"
  }, (0, _preact.h)("img", {
    height: 64,
    width: 64,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath'), "images/integrations/").concat(appLogoName, ".png"))
  }))), installButton), (0, _preact.h)("section", {
    className: "installation-right__section"
  }, (0, _preact.h)(_inactivityBanner.default, {
    appName: headerTitle,
    activityStatus: shouldShowInactivityBanner
  }), (0, _preact.h)("div", {
    className: "installation-right__section__cntr"
  }, (0, _preact.h)("div", {
    className: "installation__description_container"
  }, (0, _preact.h)("h5", {
    className: "installation__description_title"
  }, "Description"), (0, _preact.h)("p", {
    className: "installation__description_text"
  }, description), displayShowMoreLink && (0, _preact.h)("a", {
    className: "installation__description_show-more-link"
  }, " Show more ")), (0, _preact.h)("div", {
    className: "installation__tabs"
  }, (0, _preact.h)(_tabs.default, {
    titles: tabTitles,
    onCallback: function onCallback(selectedTab) {
      return onClickTab(selectedTab);
    },
    activeTab: activeTab,
    dataProgressBannerSlot: shouldShowBanner ? (0, _preact.h)(DataProgressBanner, null) : null
  }, tabContents))))), uninstallModal);
};

var _default = IntegrationSetup;
exports.default = _default;